import { observeElement } from '@uvocore-front/utils';
import '../../components/ImagesLazyLoading';
import '../../components/NotifyWidget';
import '../../components/Calculator/CalculatorDefault';
import '../../components/Calculator/CalculatorShort';
import '../../components/SamplesIframe';
import '../../components/Testimonials';
import '../../all_pages/js/testimonials';
import '../../all_pages/js/headerScroll';
import '../../all_pages/js/toggleMenu';
import '../../all_pages/js/dropdown';
import Accordion from '../../components/Accordion';
import Popup from '../../components/PopupBanner';
import { exitPopupTemplate1 } from '../../components/PopupBanner/popupTemplates';

if (document.querySelector('[data-popup-js]')) {
  const popup = new Popup({
    container: '[data-popup-js]',
    // storage: 'cookie',
    template: exitPopupTemplate1,
    gaEventLabel: 'PopupBanner',
    bannerName: 'popup-banner',
    hideForExistsUsers: true,
    analytics: {
      type: 'ga',
    },
  });

  setTimeout(() => {
    popup.init();
  }, 5000);
}


observeElement({
  element: '.AccordionBox',
  marginValue: 300,
  callback: () => {
    Accordion();
  },
});

/**
 * ToggleListAccordion
 * for commonPages
 */
function toggleListAccordionInit() {
  if (!document.querySelector('.toggle-list')) return false;

  if (!document.querySelector('.toggle-list .calculate-height')) {
    [...document.querySelectorAll('.toggle-list .toggle-content')].forEach((i) => {
      // eslint-disable-next-line no-param-reassign
      i.innerHTML = `<div class='calculate-height'>${i.innerHTML}</div>`;
    });
  }

  return Accordion({
    faqContainer: document.querySelector('.toggle-list'),
    headingSelector: '.toggle-link',
    contentSelector: '.calculate-height',
    faqItemsSelector: '.toggle-list > li',
    contentWrapperSelector: '.toggle-content',
  });
}

// common pages
const commonPage = document.getElementById('CommonPage');
if (commonPage) {
  observeElement({
    element: '[data-site-id]',
    marginValue: 100,
    callback: () => {
      function init() {
        const pageName = commonPage.getAttribute('data-page');
        const siteId = commonPage.getAttribute('data-site-id');
        const policies = commonPage.getAttribute('data-policies');
        const policyId = commonPage.getAttribute('data-policy-id');

        let widgetOptions = {
          siteId,
          pageName,
        };

        if (policies && policyId) {
          widgetOptions = { ...widgetOptions, policies, policyId };
        }

        window.commonPagesWidget.widget(commonPage, widgetOptions);
      }

      if (typeof window.commonPagesWidget !== 'undefined') {
        init();
      } else {
        const script = document.createElement('script');
        script.src = '/assets/js/commonPagesWidget.min.js';
        script.async = true;
        script.onload = function () {
          init();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
      }

      window.addEventListener('contentRendered', toggleListAccordionInit);
    },
  });
}

// fix for faq page
if (document.querySelector('[data-page="frequently_asked_questions"]')) {
  document.addEventListener('DOMContentLoaded', toggleListAccordionInit);
}
